import { useNavigate } from 'react-router-dom';
import { Mail, ArrowLeft, Globe } from 'lucide-react';
import { useLanguage } from '@/context/LanguageContext';
import { useTranslation } from '@/utils/i18n';

function Contact() {
  const navigate = useNavigate();
  const { language } = useLanguage();
  const { t } = useTranslation(language);

  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white">
      <div className="max-w-4xl mx-auto px-6 py-12">
        <button
          onClick={() => navigate('/')}
          className="flex items-center gap-2 text-gray-400 hover:text-[#ff6b35] transition-colors mb-8"
        >
          <ArrowLeft className="w-5 h-5" />
          {t('backToHome')}
        </button>

        <div className="flex items-center gap-3 mb-6">
          <Mail className="w-8 h-8 text-[#ff6b35]" />
          <h1 className="text-4xl font-bold gradient-text">{t('contactUs')}</h1>
        </div>

        <div className="bg-[#1a1a1a] border border-[#ff6b35]/20 rounded-xl p-8 space-y-6">
          <div className="space-y-8 text-gray-300 leading-relaxed">
            <div>
              <h2 className="text-xl font-semibold text-white mb-4">{t('contactTitle')}</h2>
              
              <div className="space-y-4">
                <div className="flex items-center gap-3">
                  <Mail className="w-5 h-5 text-[#ff6b35]" />
                  <div>
                    <p className="text-sm text-gray-400">{t('contactSupport')}</p>
                    <a href="mailto:support@donotbull.com" className="text-[#ff6b35] hover:underline font-medium">
                      support@donotbull.com
                    </a>
                  </div>
                </div>

                <div className="flex items-center gap-3">
                  <Mail className="w-5 h-5 text-[#ff6b35]" />
                  <div>
                    <p className="text-sm text-gray-400">{t('contactGeneral')}</p>
                    <a href="mailto:contact@donotbull.com" className="text-[#ff6b35] hover:underline font-medium">
                      contact@donotbull.com
                    </a>
                  </div>
                </div>

                <div className="flex items-center gap-3">
                  <Globe className="w-5 h-5 text-[#ff6b35]" />
                  <div>
                    <p className="text-sm text-gray-400">{t('contactWebsite')}</p>
                    <a href="https://www.donotbull.com" className="text-[#ff6b35] hover:underline font-medium">
                      www.donotbull.com
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-[#ff6b35]/10 border border-[#ff6b35]/30 rounded-lg p-6">
              <p className="text-sm text-white font-semibold mb-3">
                {language === 'fr' ? 'Informations légales' : language === 'es' ? 'Información legal' : 'Legal Information'}
              </p>
              <div className="space-y-1 text-sm text-gray-300">
                <p><span className="text-orange-400 font-semibold">Do Not Bull</span> {language === 'fr' ? 'est une marque de' : language === 'es' ? 'es una marca de' : 'is a brand of'} <span className="text-white font-semibold">Strategy Intelligence Solutions LTD</span></p>
                <p>{language === 'fr' ? 'Enregistrée en Angleterre et au Pays de Galles' : language === 'es' ? 'Registrada en Inglaterra y Gales' : 'Registered in England & Wales'}</p>
                <p>{language === 'fr' ? 'Numéro de société' : language === 'es' ? 'Número de empresa' : 'Company No.'}: <span className="text-white">16760736</span></p>
                <p>{language === 'fr' ? 'Siège social' : language === 'es' ? 'Sede social' : 'Registered office'}: <span className="text-white">128 City Road, London EC1V 2NX, United Kingdom</span></p>
              </div>
            </div>
          </div>

          <div className="pt-6 border-t border-gray-800">
            <p className="text-sm text-gray-400">{t('contactResponse')}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;